import * as React from 'react';

import {Carousel} from 'antd';

import NavTabs from '@app/components/UI/NavTabs/NavTabs';
import ModalVideo from '@app/components/UI/ModalVideo/ModalVideo';

import '@app/scss/components/foundersBlock.scss';

interface FoundersBlockProps {
	name: string;
	foundersRef?: any;
}

const FoundersBlock: React.FC<FoundersBlockProps> = (props) => {
	const navItems = [
		{
			name: 'first',
			title: 'Dr. Dani McVety',
		},
		{
			name: 'second',
			title: 'Dr. Mary Gardner'
		}
	];

	const foundersInfo = [
		{
			name: 'Dr. Dani McVety',
			role: 'Founder and CEO',
			description: 'In addition to her role as a hospice veterinarian and Founder & CEO of Lap of Love, Dani McVety is a speaker, consultant, author, and host for PetCareTV. With a deep love for the human-animal bond, Dr. Dani enjoys just about anything that has to do with pets! After graduating from college, she practiced emergency medicine and gained a greater understanding of how to help families at a time in which they felt most helpless. This has become her greatest fulfillment in veterinary medicine: helping to ease the stress and fear of the people who love their animals. Already an accomplished entrepreneur before vet school graduation, Dr. Dani partnered with Dr. Mary Gardner about one year after founding Lap of Love. Together they have grown the company into one of the most respected networks of doctors in the veterinary profession, setting the standard for end-of-life care higher than it has ever been before. Dr. Dani graduated from the University of Florida College of Veterinary Medicine and is the youngest recipient of the college’s Distinguished Young Alumni Award (2013), the Florida Veterinary Medical Association’s President’s Award (2014), and most recently, the Pet Industry Woman of the Year (2017).',
			img: require('@app/content/founder-dani.jpg'),
			videoSrc: 'https://www.youtube.com/embed/NRgCGQSYZV0?showinfo=0',
			alt: 'Dr. Dani McVety'
		},
		{
			name: 'Dr. Mary Gardner',
			role: 'Co-Founder and CIO',
			description: <>There is nothing better to Dr. Gardner than a dog with a grey muzzled dog or skinny old cat!
				Her professional goal is to increase awareness and medical care for the geriatric veterinary patient and
				to help make the final life stage to be as peaceful as possible, surrounded with dignity and support for
				all involved.
				<br/><br/>
				Dr. Mary Gardner didn’t grow up hoping to become a veterinarian. After graduating from the University of
				Miami, she began working as a trainer for an enterprise wide order management software. After learning
				the intricacies of the software and the variety of ways different businesses used it, she moved into a
				Business Architect role where she led the design of new software initiatives. Her innate talent for
				understanding logistics in a client-centric organization developed a unique skill set for a
				veterinarian. After 10 years in software she found herself longing for something different and more
				meaningful – the path she selected was to become a veterinarian. She completed her Doctorate of
				Veterinary Medicine in 2008 from the University of Florida. She worked in general medicine at a
				veterinary clinic in south Florida for two years before discovering her niche in end of life care.
				<br/><br/>
				Dr. Gardner is a published author for many articles and a textbook, speaks all around the world on
				geriatrics and end of life care and was voted 2020 VMX Small Animal Speaker of the year!
			</>,
			img: require('@app/content/mary-sam-and-duncan-small.jpg'),
			videoSrc: 'https://www.youtube.com/embed/sACwZ_dFmAg?showinfo=0',
			alt: 'Dr. Mary Gardner'
		}
	];

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const slider = React.useRef<any>();
	const [modalVisible, setModalVisible] = React.useState({0: false, 1: false});

	const onSetIssue = (index) => {
		setCurrentIndex(index);
		slider.current.goTo(index);
	};

	return (
		<div className="founders" id={props.name} ref={props.foundersRef!}>
			<div className="founders__wrapper" id="modalMount">
				<div className="founders__body">
					<div className="founders__body-left">
						<h2 className="founders__body-left-title">
							Our founders
						</h2>
						<NavTabs
							navItems={navItems}
							currentIndex={currentIndex}
							onSetIssue={onSetIssue}
							navCollapse={undefined}
							onChange={undefined}
						/>
					</div>
					<div className="founders__body-right">
						<Carousel
							effect="fade"
							ref={slider}
							afterChange={setCurrentIndex}
							dots={false}

						>
							{
								foundersInfo.map((item, index) => (
									<div key={index} className="founders__body-right-slide">
										<div className="founders__body-right-slide-vet">
											<div className="founders__body-right-slide-vet-img">
												<img src={item.img} alt={item.alt} />
											</div>
											<button 
												className="founders__body-open-modal"
												onClick={() => {
													setModalVisible({...modalVisible, [index]: true});
												}}
											/>
										</div>
										<div className="founders__body-right-slide-descr">
											<div className="founders__body-right-slide-descr-personal">
												<img src={item.img} alt="founder-avatar"/>
												<div>
													<h3>{item.name}</h3>
													<h4>{item.role}</h4>
												</div>
											</div>
											<p>{item.description}</p>
											<button
												className="founders__body-open-modal founders__body-open-modal-mobile"
												onClick={() => {
													setModalVisible({...modalVisible, [index]: true});
												}}
											/>
										</div>
										<ModalVideo modalVisible={modalVisible[index]} setModalVisible={setModalVisible}
													videoSrc={item.videoSrc} getContainer="#founders"/>
									</div>
								))
							}
						</Carousel>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FoundersBlock;